
/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/invalidateAndEditConfirmationModal/invalidateAndEditConfirmationModal"/>
import * as React from "react";
import { Button, DialogPart, ModalDialogShell, Text } from "@medius/ui-controls";
import { translate } from "Core/Medius.Core.Web/Scripts/lib/globalization";

export interface InvalidateAndEditConfirmationModalProps{
    isInvalidateModalVisible: boolean;
    isInvaldiateAndEditHidden?: boolean;
    isDisabled: boolean;
    hideInvalidateModal: () => void;
    handleInvalidateButton: () => void;
    invalidateAndEdit?: () => void;
}

export const InvalidateAndEditConfirmationModal = ({ isInvalidateModalVisible, isInvaldiateAndEditHidden, isDisabled, hideInvalidateModal, handleInvalidateButton, invalidateAndEdit }: InvalidateAndEditConfirmationModalProps) => 
{
    return (
        <ModalDialogShell 
            title={translate("#Core/invoice/areYouSureYouWantToInvalidateThisInvoice")} 
            hasHeader 
            isOpen={isInvalidateModalVisible} 
            onRequestClose={hideInvalidateModal}
            data-testid="task-group-modal">
          {dialogProps => 
            <>
              <DialogPart.Header {...dialogProps.headerProps}>
                  <Text
                      variant="heading2">{translate("#Core/invoice/areYouSureYouWantToInvalidateThisInvoice")}
                  </Text>
              </DialogPart.Header>
                <DialogPart.ActionsFooter actionAlignment="center">
                  <Button label={translate("#Core/cancel")} variant="inline" onClick={hideInvalidateModal} data-testid="close-popup"/>   
                  {!isInvaldiateAndEditHidden && <Button label={translate("#Core/invalidateAndEdit")} variant="secondary" disabled={isDisabled} onClick={invalidateAndEdit} data-testid="register-again-document"/>}
                  <Button label={translate("#Enterprise/invalidate")} variant="secondary" disabled={isDisabled} onClick={handleInvalidateButton} data-testid="task-handle-action task-handle-action-main"/>
                </DialogPart.ActionsFooter>
            </>}
        </ModalDialogShell>
    );
};